import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1911b4ec"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\User\\Documents\\legalmerge-prod\\legal-merge\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1911b4ec')) {
      api.createRecord('1911b4ec', component.options)
    } else {
      api.reload('1911b4ec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1911b4ec", function () {
      api.rerender('1911b4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BadLeadDialog/index.vue"
export default component.exports